import { SessionStorageService } from 'src/app/shared/services/storage/session-storage/session-storage.service';
import { Component } from '@angular/core';
import { INavLink, IUtilityVersion } from 'src/app/common/interface/nav-link.interface';
import { navbarLinks, FEATURES, LIBRARY, US_REGION, GENAI_ENABLED, CONTROLS_ENABLED } from 'src/app/common/constants/app.constants';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HasAccessDirective } from 'src/app/shared/directives/access/has-access.directive';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import { IUserDetails } from 'src/app/common/interface/user.interface';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from 'src/environments/environment';
import { AdobeAnalyticsService } from 'src/app/shared/services/adobe-analytics/adobe-analytics.service';
import { GlobalInstancesService } from 'src/app/shared/services/global-instance/global-instance.service';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { DisclaimerBoxComponent } from '../projects/components/disclaimer-box/disclaimer-box.component';
import { CommonModule } from '@angular/common';
import { AskMeComponent } from 'src/app/shared/components/ask-me/ask-me.component';
declare var Optanon: any;

@Component({
    selector: 'app-navigation-bar',
    imports: [MatToolbarModule, HasAccessDirective, MatButtonModule, MatMenuModule, MatDividerModule, RouterLink, RouterLinkActive, MatTooltipModule, CommonModule],
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent {

  navlinks: INavLink[] = navbarLinks;
  FEATURES = FEATURES;
  userDetails: IUserDetails;
  userInitials: string;
  //For help feature
  help: string;
  arrowIsRotatedUp: boolean = false;
  isGenAIEnabled: boolean = false;
  commonBaseUrl: string;
  utilityVersions: IUtilityVersion[]

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly sessionStorageService: SessionStorageService,
    private adobeAnalyticService: AdobeAnalyticsService,
    private readonly globalInstanceService: GlobalInstancesService,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService
  ) {
    this.getInitials();
  }

  ngOnInit() {
    this.isGenAIEnabled = false;
    this.loggingLogsInAdobe();
    this.fetchCurrentGlobalInstance();
    this.sharedService.genAIEnabled$.subscribe((isEnabled) => {
      this.isGenAIEnabled = isEnabled;
    });
    this.sharedService.getTestAiRecorderVersions().pipe().subscribe((data) => {
      this.utilityVersions = data.versions.sort((a, b) =>
          b.version.localeCompare(a.version)
      );
      this.utilityVersions.forEach((version) => {
          const versionDate = new Date(version.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          });
          version.date = versionDate;
      });
    });
  }

  /**
   * loggingLogsInAdobe: method will be used to set the details of page and log to adobe server
   */
  loggingLogsInAdobe = () => {
    if (environment.IS_ADOBE_ANALYTICS_ENABLED) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.adobeAnalyticService.setApplicationName("TestAI");
          this.adobeAnalyticService.setUserId();
          this.adobeAnalyticService.setPageName(event.url);
          this.adobeAnalyticService.trackActionEvent("pageView");
        }
      });
    }
  }

  handleLogoClick(){
    this.router.navigate([''])
  }

  /**
   * Fetches the current global instance details and sets the common base URL
   */
  fetchCurrentGlobalInstance = () => {
    const host = location.origin;
    
    this.globalInstanceService
      .getGlobalInstances()
      .pipe()
      .subscribe((res) => {
        res.forEach((ele) => {
          if (ele?.instanceName === US_REGION) {
            this.commonBaseUrl = !environment?.isLocal
              ? ele?.applicationUrl
              : host;
          }
        });
      });
  };

  /**
   * TODO: We are explicitly setting the library URL to US as we need to redirect it to US region.
   * This will be in place until we implement the region specific library page.
   */
  handleClick(link, index) {
    if (index === 0) {
      if (link.label.toLowerCase() === LIBRARY.toLowerCase()) {
        this.sessionStorageService.setValue('taxonomyData', null);
        this.sessionStorageService.setValue('projectData', null);
        this.sessionStorageService.setValue(CONTROLS_ENABLED, false);
        window.location.href = `${this.commonBaseUrl}/library`;
      }
      //todo: add implementation for projects flow later if required
    }
  }

  cookies() {
    window.open('https://cookienotice.deloitte.com');
  }

  navigateToPrivacy() {
    window.open(environment.PRIVACY_POLICY_LINK, '_blank');
  }

  getInitials() {
    this.userDetails = JSON.parse(JSON.stringify(this.sessionStorageService.getValue("userDetails")));
    let userName = this.userDetails?.name;
    let initials = userName?.replace(/\s+/g, '')?.split(",");
    this.userInitials = initials?.length > 1 ? initials[0][0] + initials[1][0] : initials?.join(' ');
    if (this.userDetails?.name?.includes(',')) {
      this.userDetails.name = this.userDetails?.name?.replace(',', "");
    }
  }

  cookieSettings() {
    Optanon?.ToggleInfoDisplay();
  }

  navigateToLicenses() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/white-source-license']));
    window.open(url, '_blank');
  }

  userGuide(){
    window.open('https://kx.deloitte/documents/view/94337');
  }

  /**
   * Opens the "Ask Me" dialog in full-screen mode, allowing users to interact with the AskMeComponent.
   * Passes message, accepted status, and projectId as data to the dialog.
   *
   * @returns {void}
   */
  askMe = () => {
    const dialogRef = this.dialog.open(AskMeComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'full-screen-dialog',
      backdropClass: 'no-backdrop',
      disableClose: true,
      autoFocus: false,
      data: {},
    })
  }

  serviceRequest(){
    window.open('https://deloitteus.service-now.com/sp?id=sc_cat_item&sys_id=0027aca34f3bd7c433c77bcd0210c72d&table=sc_cat_item&sysparm_value=TestAI');
  }

  /**
  * Opens a disclaimer dialog for the current project and user.
  *
  * @returns {void}
  */
  disclaimer = () => {
    const projectData = this.sessionStorageService.getValue('projectData');
    this.sharedService.getUserGenAITC(projectData.projectId).subscribe((res) => {
      const dialogRef = this.dialog.open(DisclaimerBoxComponent, {
        width: '704px',
        height: '576px',
        panelClass: 'disclaimer-dialog-panel',
        disableClose: true,
        autoFocus: false,
        data: {
          message: " " + res?.terms,
          accepted: res?.accepted,
          projectId: projectData.projectId
        },
      })
    })
  }

  /**
   * TrainingCourse: method will be used to open the training course link.
   */
  trainingCourse = () => 
    window.open(environment.TRAINING_COURSE_LINK);
  
  /**
   * RequestDemo: method will be used to open the request demo link.
   */
  requestDemo = () => 
    window.open(
      "https://deloittesurvey.deloitte.com/Community/se/3FC11B267BCB7956"
    )
  
  arrowRotate(){
    this.arrowIsRotatedUp = !this.arrowIsRotatedUp;
  }

  arrowReset(){
    this.arrowIsRotatedUp = false;
  }


  /**
   * LogOut: method logs the user out by invoking the
   * logout functionality from the authentication service.
   */
  logOut = () => this.authenticationService.logOutWithPopup();

  /**
   * Downloads a utility file for the specified version by fetching its details from the server.
   * The file is expected to be in Base64 format and is converted to a downloadable ZIP file.
   *
   * @param version - The version of the TestAI Recorder utility to download.
   * 
   * @throws Will log an error if the file is not found in the response or if the request fails.
   */
  downloadUtility = (version: string) => {
    this.sharedService.getTestAiRecorderVersionDetails(version).pipe().subscribe((data: any) => {
      if (data?.file) {
        const byteCharacters = atob(data.file);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        const fileName = `TestAI_Recorder_${version}.zip`;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Failed to download file: No base64ZipFile found in response');
      }
    }, (error) => {
      console.error('Error fetching version details:', error);
    });
  }
}
